import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { UpdateOrganizationComponent } from './update-organization/update-organization.component'
import { CreateOrganizationComponent } from './create-organization/create-organization.component'
import { OrganizationsComponent } from './organizations.component'
import { organizationsRoutes } from './organizations.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    OrganizationsComponent,
    CreateOrganizationComponent,
    UpdateOrganizationComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(organizationsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    OrganizationsComponent,
    CreateOrganizationComponent,
    UpdateOrganizationComponent,
  ],
})
export class OrganizationsModule {}
